import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCategorisingList, getReasons, setCategorisingList } from "./selectionCategories.thunks";
import { CategorisingInterface } from "./selectionCategories.types";

interface SelectionCategoriesState {
	categorisingList: any[];
	reasons: any[];
	isFinish: boolean;
	category: number | null;
	loading: boolean;
}

const initialState: SelectionCategoriesState = {
	categorisingList: [],
	reasons: [],
	isFinish: false,
	category: null,
	loading: false,
};

const selectionCategoriesSlice = createSlice({
	name: "viewDocumentsSlice",
	initialState,
	reducers: {
		unFinish(state) {
			state.isFinish = false;
		},

		clearCategorisingList(state) {
			state.categorisingList = [];
		},

		setCategory(state, action: PayloadAction<number>) {
			state.category = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getCategorisingList.fulfilled, (state, action: PayloadAction<CategorisingInterface[]>) => {
			state.categorisingList = action.payload;
		});

		builder.addCase(setCategorisingList.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(setCategorisingList.fulfilled, (state) => {
			state.loading = false;
		});

		builder.addCase(setCategorisingList.rejected, (state) => {
			state.loading = false;
		});

		builder.addCase(getReasons.fulfilled, (state, action: PayloadAction<any>) => {
			state.reasons = action.payload;
		});
	},
});

export const { unFinish, clearCategorisingList, setCategory } = selectionCategoriesSlice.actions;
export default selectionCategoriesSlice.reducer;
